<template>
  <div>
    <div class="tabs">
      <ul class="flex flex-col sm:flex-row">
        <li
          v-for="tab in tabs"
          :class="{ 'is-active text-teal-400 border-teal-400': tab.isActive }"
          :key="tab.id"
          class="mr-1"
        >
          <a
            :href="tab.href"
            @click="selectTab(tab)"
            class="border-b inline-block py-2 pr-8 text-center font-semibold hover:text-teal-400 hover:border-teal-400"
          >
            {{ tab.name }}
          </a>
        </li>
      </ul>
    </div>

    <div class="tabs-details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { tabs: [] };
  },

  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name == selectedTab.name;
      });
    }
  }
};
</script>

<style></style>
